import { Collapse, Typography } from "antd";
import React from "react";
import DailyCommonCols from "./DailyCommonCols";

const DailyRoutine = ({ data }) => {
  const bathData = data?.bath_sponge;
  const bowelData = data?.bowel;
  const hairData = data?.hair_care;
  const nailData = data?.nail_care;
  const oralData = data?.oral_care;
  const skinData = data?.skin_care;

  const hasBath = bathData?.length > 0;
  const hasBowel = bowelData?.length > 0;
  const hasHair = hairData?.length > 0;
  const hasNail = nailData?.length > 0;
  const hasOral = oralData?.length > 0;
  const hasSkin = skinData?.length > 0;

  if (!hasBath && !hasBowel && !hasHair && !hasNail && !hasOral && !hasSkin) {
    return (
      <div style={{ textAlign: "center", padding: "24px 0", color: "#98A2B3" }}>
        <Typography.Text type="secondary">No daily routine items</Typography.Text>
      </div>
    );
  }

  const defaultKeys = [];
  if (hasBath) defaultKeys.push("1");
  if (hasBowel) defaultKeys.push("2");
  if (hasHair) defaultKeys.push("3");
  if (hasNail) defaultKeys.push("4");
  if (hasOral) defaultKeys.push("5");
  if (hasSkin) defaultKeys.push("6");

  return (
    <div>
      <Collapse
        expandIconPosition="end"
        className="custom-collapse"
        defaultActiveKey={defaultKeys}
      >
        {hasBath && (
          <Collapse.Panel header="Bath / Sponge" key="1">
            <DailyCommonCols data={bathData} />
          </Collapse.Panel>
        )}
        {hasBowel && (
          <Collapse.Panel header="Bowel" key="2">
            <DailyCommonCols data={bowelData} />
          </Collapse.Panel>
        )}
        {hasHair && (
          <Collapse.Panel header="Hair Care" key="3">
            <DailyCommonCols data={hairData} />
          </Collapse.Panel>
        )}
        {hasNail && (
          <Collapse.Panel header="Nail Care" key="4">
            <DailyCommonCols data={nailData} />
          </Collapse.Panel>
        )}
        {hasOral && (
          <Collapse.Panel header="Oral Care" key="5">
            <DailyCommonCols data={oralData} />
          </Collapse.Panel>
        )}
        {hasSkin && (
          <Collapse.Panel header="Skin Care" key="6">
            <DailyCommonCols data={skinData} />
          </Collapse.Panel>
        )}
      </Collapse>
    </div>
  );
};

export default DailyRoutine;
